// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selections-template {\n\theight: 70px;\n}", "",{"version":3,"sources":["webpack://src/components/Clients/Templates/styles.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb","sourcesContent":[".selections-template {\n\theight: 70px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
